import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import { isConstructor } from '@pct-ts/typeguard';
import type { Constructor } from '@pct-ts/typing';

@Pipe({
  name: 'isConstructor',
})
export class IsConstructorPipe implements PipeTransform {
  transform<T>(value: unknown): value is Constructor<T> {
    return isConstructor<T>(value);
  }
}
